import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "panel-pad mb-4" }
const _hoisted_3 = { class: "flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col gap-2 border-slate-200 pt-3 text-left lg:min-w-[360px] lg:border-l lg:pl-4 lg:pt-0"
}
const _hoisted_5 = { class: "flex items-end justify-between gap-3" }
const _hoisted_6 = { class: "mt-1 text-sm font-semibold text-slate-700" }
const _hoisted_7 = { class: "text-xl font-black text-ink" }
const _hoisted_8 = {
  key: 0,
  class: "table-loading-overlay"
}
const _hoisted_9 = { class: "data-table min-w-[1500px] w-full" }
const _hoisted_10 = { class: "divide-y divide-slate-100" }
const _hoisted_11 = { class: "font-semibold text-ink" }
const _hoisted_12 = { class: "text-right" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "mb-4 flex items-start justify-between gap-3" }
const _hoisted_15 = { class: "text-xl font-bold text-ink" }
const _hoisted_16 = { class: "grid gap-4 md:grid-cols-2" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "mt-4 flex justify-end gap-3" }
const _hoisted_19 = { class: "mb-4 flex items-start justify-between gap-3" }
const _hoisted_20 = { class: "text-xl font-bold text-ink" }
const _hoisted_21 = { class: "mt-4 flex justify-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_UiPageHero = _resolveComponent("UiPageHero")!
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_UiPagination = _resolveComponent("UiPagination")!
  const _component_UiSelect = _resolveComponent("UiSelect")!
  const _component_UiDatePicker = _resolveComponent("UiDatePicker")!
  const _component_UiTextarea = _resolveComponent("UiTextarea")!
  const _component_UiModal = _resolveComponent("UiModal")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_UiPageHero, {
      eyebrow: "Bảo trì bảo dưỡng",
      title: "Lịch sử bảo dưỡng",
      description: "Theo dõi lịch bảo dưỡng thiết bị, chi phí và trạng thái xử lý."
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_UiButton, {
          variant: "white",
          icon: "add",
          onClick: $setup.openCreateModal
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createTextVNode(" Tạo lịch ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_UiInput, {
          modelValue: $setup.query,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.query) = $event)),
          class: "w-full lg:max-w-md",
          placeholder: "Tìm thiết bị, mã, khoa/phòng, ghi chú..."
        }, null, 8, ["modelValue"]),
        ($setup.canManageConfig)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-[11px] font-bold uppercase text-slate-500" }, " Cấu hình bảo dưỡng ", -1)),
                  _createElementVNode("p", _hoisted_6, [
                    _cache[12] || (_cache[12] = _createTextVNode(" Thời gian mặc định: ", -1)),
                    _createElementVNode("span", _hoisted_7, _toDisplayString($setup.configLoading
                      ? "..."
                      : $setup.currentConfig?.thoiGianBaoDuong ?? "-"), 1)
                  ])
                ]),
                ($setup.currentConfig)
                  ? (_openBlock(), _createBlock(_component_UiButton, {
                      key: 0,
                      variant: "secondary",
                      icon: "edit",
                      onClick: $setup.openUpdateConfigModal
                    }, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                        _createTextVNode(" Cập nhật ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_UiButton, {
                      key: 1,
                      icon: "add",
                      disabled: $setup.configLoading,
                      onClick: $setup.openCreateConfigModal
                    }, {
                      default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                        _createTextVNode(" Tạo cấu hình ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled", "onClick"]))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["table-wrap", { 'is-loading': $setup.loading }])
    }, [
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[16] || (_cache[16] = [
            _createElementVNode("span", { class: "table-spinner" }, null, -1),
            _createElementVNode("span", null, "Đang tải dữ liệu...", -1)
          ]))]))
        : _createCommentVNode("", true),
      _createElementVNode("table", _hoisted_9, [
        _cache[19] || (_cache[19] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, "STT"),
            _createElementVNode("th", null, "Tên thiết bị"),
            _createElementVNode("th", null, "Mã thiết bị"),
            _createElementVNode("th", null, "Khoa/phòng hiện tại"),
            _createElementVNode("th", null, "Thời gian bảo dưỡng"),
            _createElementVNode("th", null, "Thời gian bảo dưỡng tiếp theo"),
            _createElementVNode("th", null, "Số tiền"),
            _createElementVNode("th", null, "Trạng thái"),
            _createElementVNode("th", null, "Ghi chú"),
            _createElementVNode("th", null, "Thao tác")
          ])
        ], -1)),
        _createElementVNode("tbody", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.paginatedRows, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: item.id || `${item.idThietBi}-${index}`,
              class: "hover:bg-slate-50"
            }, [
              _createElementVNode("td", null, _toDisplayString($setup.rowIndex(index)), 1),
              _createElementVNode("td", _hoisted_11, _toDisplayString(item.thietBi?.tenThietBi || "-"), 1),
              _createElementVNode("td", null, _toDisplayString(item.thietBi?.maThietBi || "-"), 1),
              _createElementVNode("td", null, _toDisplayString(item.thietBi?.khoaPhongHienTai || "-"), 1),
              _createElementVNode("td", null, _toDisplayString($setup.formatDate(item.thoiGianBaoDuong)), 1),
              _createElementVNode("td", null, _toDisplayString($setup.formatDate(item.thoiGianBaoDuongTiepTheo)), 1),
              _createElementVNode("td", null, _toDisplayString($setup.formatCurrency(item.soTien)), 1),
              _createElementVNode("td", null, [
                _createElementVNode("span", {
                  class: _normalizeClass($setup.statusClass(item.trangThai))
                }, _toDisplayString(item.trangThai ? "Hoàn thành" : "Chưa hoàn thành"), 3)
              ]),
              _createElementVNode("td", null, _toDisplayString(item.ghiChu || "-"), 1),
              _createElementVNode("td", _hoisted_12, [
                _createVNode(_component_UiButton, {
                  variant: "secondary",
                  size: "sm",
                  icon: "edit",
                  onClick: ($event: any) => ($setup.openUpdateModal(item))
                }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createTextVNode(" Cập nhật ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]))
          }), 128)),
          (!$setup.filteredRows.length && !$setup.loading)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [...(_cache[18] || (_cache[18] = [
                _createElementVNode("td", {
                  colspan: "10",
                  class: "py-10 text-center text-slate-500"
                }, " Không có dữ liệu bảo dưỡng phù hợp. ", -1)
              ]))]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2),
    _createVNode(_component_UiPagination, {
      modelValue: $setup.page,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.page) = $event)),
      total: $setup.filteredRows.length,
      "page-size": $setup.pageSize
    }, null, 8, ["modelValue", "total", "page-size"]),
    ($setup.showMaintenanceModal)
      ? (_openBlock(), _createBlock(_component_UiModal, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submitMaintenance && $setup.submitMaintenance(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_15, _toDisplayString($setup.maintenanceModalTitle), 1)
                ]),
                _createVNode(_component_UiButton, {
                  variant: "ghost",
                  size: "sm",
                  icon: "close",
                  onClick: $setup.closeMaintenanceModal
                }, {
                  default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                    _createTextVNode(" Đóng ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                ($setup.maintenanceMode === 'create')
                  ? (_openBlock(), _createBlock(_component_UiSelect, {
                      key: 0,
                      modelValue: $setup.maintenanceForm.idThietBi,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.maintenanceForm.idThietBi) = $event)),
                      modelModifiers: { number: true },
                      class: "md:col-span-2",
                      label: "Thiết bị",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _cache[21] || (_cache[21] = _createElementVNode("option", { value: 0 }, "Chọn thiết bị", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.devices, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item.id,
                            value: item.id
                          }, _toDisplayString(item.tenThietBi) + " - " + _toDisplayString(item.maThietBi || "Chưa có mã"), 9, _hoisted_17))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : (_openBlock(), _createBlock(_component_UiInput, {
                      key: 1,
                      "model-value": $setup.maintenanceDeviceLabel,
                      class: "md:col-span-2",
                      label: "Thiết bị",
                      disabled: ""
                    }, null, 8, ["model-value"])),
                _createVNode(_component_UiDatePicker, {
                  modelValue: $setup.maintenanceForm.thoiGianBaoDuong,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.maintenanceForm.thoiGianBaoDuong) = $event)),
                  label: "Thời gian bảo dưỡng",
                  required: ""
                }, null, 8, ["modelValue"]),
                _createVNode(_component_UiDatePicker, {
                  modelValue: $setup.maintenanceForm.thoiGianBaoDuongTiepTheo,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.maintenanceForm.thoiGianBaoDuongTiepTheo) = $event)),
                  label: "Bảo dưỡng tiếp theo",
                  required: ""
                }, null, 8, ["modelValue"]),
                ($setup.maintenanceMode === 'update')
                  ? (_openBlock(), _createBlock(_component_UiSelect, {
                      key: 2,
                      modelValue: $setup.maintenanceForm.trangThai,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.maintenanceForm.trangThai) = $event)),
                      label: "Trạng thái",
                      required: ""
                    }, {
                      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                        _createElementVNode("option", { value: false }, "Chưa hoàn thành", -1),
                        _createElementVNode("option", { value: true }, "Hoàn thành", -1)
                      ]))]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_UiInput, {
                  "model-value": $setup.maintenanceCostInput,
                  class: _normalizeClass($setup.maintenanceMode === 'update' ? '' : 'md:col-span-2'),
                  label: "Số tiền",
                  inputmode: "numeric",
                  required: "",
                  onKeydown: $setup.blockNonNumericKey,
                  onPaste: _cache[6] || (_cache[6] = ($event: any) => ($setup.pasteNumericOnly($event, $setup.updateMaintenanceCost))),
                  "onUpdate:modelValue": $setup.updateMaintenanceCost
                }, null, 8, ["model-value", "class", "onKeydown", "onUpdate:modelValue"]),
                _createVNode(_component_UiTextarea, {
                  modelValue: $setup.maintenanceForm.ghiChu,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.maintenanceForm.ghiChu) = $event)),
                  class: "md:col-span-2",
                  label: "Ghi chú",
                  placeholder: "Nhập ghi chú bảo dưỡng"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_UiButton, {
                  type: "button",
                  variant: "secondary",
                  icon: "cancel",
                  onClick: $setup.closeMaintenanceModal
                }, {
                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                    _createTextVNode(" Hủy ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_UiButton, {
                  type: "submit",
                  icon: "confirm",
                  loading: $setup.saving,
                  disabled: $setup.isMaintenanceDisabled
                }, {
                  default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                    _createTextVNode(" Xác nhận ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ])
            ], 32)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ($setup.showConfigModal)
      ? (_openBlock(), _createBlock(_component_UiModal, { key: 1 }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submitConfig && $setup.submitConfig(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_20, _toDisplayString($setup.configModalTitle), 1),
                  _cache[25] || (_cache[25] = _createElementVNode("p", { class: "text-sm text-slate-500" }, " Nhập thời gian bảo dưỡng mặc định ", -1))
                ]),
                _createVNode(_component_UiButton, {
                  variant: "ghost",
                  size: "sm",
                  icon: "close",
                  onClick: $setup.closeConfigModal
                }, {
                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                    _createTextVNode(" Đóng ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createVNode(_component_UiInput, {
                modelValue: $setup.configForm.thoiGianBaoDuong,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.configForm.thoiGianBaoDuong) = $event)),
                modelModifiers: { number: true },
                label: "Thời gian bảo dưỡng",
                type: "number",
                min: "0",
                required: ""
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_UiButton, {
                  type: "button",
                  variant: "secondary",
                  icon: "cancel",
                  onClick: $setup.closeConfigModal
                }, {
                  default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                    _createTextVNode(" Hủy ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_UiButton, {
                  type: "submit",
                  icon: "confirm",
                  loading: $setup.configSaving,
                  disabled: $setup.configSaving
                }, {
                  default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                    _createTextVNode(" Xác nhận ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ])
            ], 32)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}